import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { useMixpanelTrack } from '@treams/treams-hooks';
import { Button, tokens } from '@treams/treams-ui';

import { AccountSwitcher } from '../navigation/TopBar';
import ProductLayout from './ProductLayout';

const Contact = styled(Flex)`
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: 50%;
	align-items: center;

	img {
		width: 64px;
		height: 64px;
		border-radius: 50%;
		flex-grow: 0;
		flex-shrink: 0;
	}
`;

const Info = styled(Box)`
	flex-grow: 1;
	flex-shrink: 1;
`;

const Name = styled(Box)`
	font-weight: bold;
`;

const Position = styled(Box)`
	color: ${tokens.text.secondary};
`;

export default function TrialExpired(props: { employee?: boolean; modal?: boolean }) {
	const { t } = useTranslation();

	useMixpanelTrack('/trial/expired');

	return (
		<ProductLayout
			modal={props.modal}
			title={t('trial.expired.title')}
			header={
				<Flex mt={3}>
					<Box flexGrow={1} flexShrink={1} />
					<Box flexGrow={0} flexShrink={0}>
						<AccountSwitcher />
					</Box>
				</Flex>
			}
			cta={
				props.employee ? (
					<Button
						type="primary"
						title={t('trial.expired.reload')}
						onClick={() => window.location.reload()}
					/>
				) : (
					<Button
						type="primary"
						title="Neem contact op"
						onClick={() => {
							(window as any).$crisp.push(['do', 'chat:open']);
							(window as any).$crisp.push([
								'set',
								'message:text',
								[t('trial.expired.chat.placeholder')],
							]);
						}}
					/>
				)
			}
		>
			<p>{t('trial.expired.subtitle')}</p>
			{props.employee ? (
				<p>{t('trial.expired.employee')}</p>
			) : (
				<p>{t('trial.expired.instruction')}</p>
			)}
			{!props.employee && (
				<Flex>
					<Contact mr={2}>
						<img src="/images/team/lucienne.jpg" alt="Luciënne van de Kar" />
						<Info ml={2}>
							<Name mb={1}>Luciënne van de Kar</Name>
							<Position>Business Development Manager</Position>
						</Info>
					</Contact>
					<Contact ml={2}>
						<img src="/images/team/yvette.png" alt="Yvette Klessens" />
						<Info ml={2}>
							<Name mb={1}>Yvette Klessens</Name>
							<Position>Business Development Manager</Position>
						</Info>
					</Contact>
				</Flex>
			)}
		</ProductLayout>
	);
}
